import React from 'react';

import { ProButton } from '@components/Button/variants';
import IconTI from '@components/Images/Rebranding/IconTI';
import { corporate_landing_path } from '@routes';

const ProTeams = () => {
  return (
    <div className="mt-48 flex flex-col items-center justify-center bg-[url('https://tii.imgix.net/global/pro/GroupSubsMobile.png?auto=format')] bg-cover px-16 py-64 sm:bg-[url('https://tii.imgix.net/global/pro/GroupSubsDesktop.png?auto=format')] sm:py-80 md:py-72 lg:mt-64">
      <IconTI className="w-28 text-primary-magenta sm:w-36" />
      <h2 className="m-0 mb-16 mt-24 max-w-[750px] text-center font-suisse-works text-headline-sm !text-black md:text-headline-md">
        Equip your teams with the resources they need to get and stay ahead.
      </h2>
      <ProButton as="link" href={corporate_landing_path()} className="mx-16 sm:mx-0">
        Learn about Group Subscriptions
      </ProButton>
    </div>
  );
};

export default ProTeams;
